

export default class URLUtil {
  static get_parameter(name, url) {
    return (new URL(url)).searchParams.get(name);
  }

  static set_parameter(name, value) {
    console.log("SET BROWSER URL");
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(name, value);
    window.location.search = searchParams.toString();
  }

  static delete_parameter(name, url) {
    const url_obj = new URL(url);
    url_obj.searchParams.delete(name);
    return url_obj.href;
  }
}



